import { Box } from '@mui/material';
import type React from 'react';

import useScreenSize from '../../../utils/useScreenSize';

interface OnboardingStepImageProps {
	src: string;
}

const OnboardingStepImage: React.FC<OnboardingStepImageProps> = ({ src }) => {
	const { isLgScreen } = useScreenSize();

	if (!isLgScreen) return null;

	return (
		<Box
			component="img"
			src={src}
			alt=""
			aria-hidden
			data-testid="onboarding-page-image"
			sx={{ display: 'block', width: 'auto', height: '100vh' }}
		/>
	);
};

export default OnboardingStepImage;
